import { Component, Input, OnInit } from '@angular/core'
import { CourtSystem } from '@ftr/contracts/api/court-system'
import { RemoteData, ScreenSize, ScreenSizeService, isMobileScreenSize } from '@ftr/foundation'
import { LogoTheme } from '@ftr/ui-core'
import { UserState } from '@ftr/ui-user'
import { Store } from '@ngxs/store'
import { Observable, distinctUntilChanged } from 'rxjs'

@Component({
  selector: 'ftr-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  @Input() logoData: RemoteData<string | undefined>

  isLoggedIn$: Observable<boolean>
  currentCourtSystem$: Observable<CourtSystem>
  private currentScreenSize: ScreenSize

  readonly logoThemes = LogoTheme

  constructor(
    private readonly store: Store,
    private readonly screenSizeService: ScreenSizeService,
  ) {}

  ngOnInit(): void {
    this.isLoggedIn$ = this.store.select(UserState.isLoggedIn).pipe(distinctUntilChanged())
    this.screenSizeService.size.subscribe(size => (this.currentScreenSize = size))
  }

  get isMobile(): boolean {
    return isMobileScreenSize(this.currentScreenSize)
  }

  get isTablet(): boolean {
    return this.currentScreenSize === ScreenSize.Medium
  }

  get isDesktop(): boolean {
    return this.currentScreenSize === ScreenSize.Large
  }

  get hasNoPersonalizedLogo(): boolean {
    return (
      this.logoData.isCompleted() &&
      !(this.logoData.isSuccess() && this.logoData._data && this.logoData._data.length > 1)
    )
  }

  get logoUrl(): string | undefined {
    return this.logoData.isSuccess() ? this.logoData._data : undefined
  }
}
